import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Base from "../admin_components/Admin_Base";
import { Button, Card, Row, Col, Form, Modal } from "react-bootstrap";
import { Breadcrumbs } from "@mui/material";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import authAxios from "../Auth/useAxios";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import { ClipLoader } from "react-spinners";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  FaUser,
  FaPhone,
  FaEnvelope,
  FaIdCard,
  FaCalendarAlt,
  FaBuilding,
  FaMapMarkerAlt,
  FaBriefcase,
  FaUsers,
  FaShieldAlt
} from "react-icons/fa";
import { toast } from "react-toastify";

const CustomerEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const [allEmployees, setAllEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [error, setError] = useState(null);
  
  // OTP Modal States
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [updateData, setUpdateData] = useState(null);

  useEffect(() => {
    fetchCustomerDetails();
    fetchAllEmployees();
  }, [id]);

  const fetchCustomerDetails = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/customer/${id}`
      );
      setCustomer(response.data);
      console.log("Customer data:", response.data);
    } catch (error) {
      console.error("Error fetching customer details:", error);
      setError("Failed to fetch customer details");
      toast.error("Failed to fetch customer details");
    } finally {
      setLoading(false);
    }
  };

  const fetchAllEmployees = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/list-employee`
      );
      setAllEmployees(response.data);
      console.log("Employees data:", response.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
      toast.error("Failed to fetch employees");
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCustomer(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleEmployeeChange = (e) => {
    const employeeId = e.target.value;
    if (employeeId === "") {
      setCustomer(prev => ({ ...prev, employee: null }));
    } else {
      const selectedEmployee = allEmployees.find(emp => emp.id === parseInt(employeeId));
      setCustomer(prev => ({ ...prev, employee: selectedEmployee }));
    }
  };

  const sendOtp = async () => {
    setSendingOtp(true);
    try {
       await authAxios.post(
        `${ADMIN_API_BASE_URL}/main/admin/send-customer-otp`, null, {
        params: { mobileNumber: customer.mobileNumber },
      }
      );
      
   
        toast.success("OTP sent successfully to your registered mobile number");
        return true;
     
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("Failed to send OTP");
      return false;
    } finally {
      setSendingOtp(false);
    }
  };

  const verifyOtp = async () => {
    if (!otp) {
      toast.error("Please enter OTP");
      return false;
    }

    setVerifyingOtp(true);
    try {
      await authAxios.post(`${ADMIN_API_BASE_URL}/main/admin/verify-customer-otp`, null, {
        params: { mobileNumber: customer.mobileNumber, otp },
      });

  
        toast.success("OTP verified successfully");
        return true;
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error("Failed to verify OTP");
      return false;
    } finally {
      setVerifyingOtp(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Prepare the data for API call
    const dataToUpdate = {
      customerName: customer.customerName,
      fatherName: customer.fatherName,
      dateOfBirth: customer.dateOfBirth,
      age: customer.age,
      aadharNumber: customer.aadharNumber,
      city: customer.city,
      email: customer.email,
      mobileNumber: customer.mobileNumber,
      nomineeName: customer.nomineeName,
      occupation: customer.occupation,
      panNumber: customer.panNumber,
      passbook: customer.passbook,
      pincode: customer.pincode,
      primaryAddress: customer.primaryAddress,
      status: customer.status,
      groupName: customer.groupName,
      employeeId: customer.employee ? customer.employee.id : null,
      documentName: customer.documentName
    };

    console.log("Preparing to update customer with data:", dataToUpdate);
    
    // Store update data and show OTP modal
    setUpdateData(dataToUpdate);
    
    // Send OTP first
    setSendingOtp(true);
    const otpSent = await sendOtp();
    setSendingOtp(false);
    
    if (otpSent) {
      setShowOtpModal(true);
    }
  };

  const handleOtpVerification = async () => {
    const isOtpValid = await verifyOtp();
    
    if (isOtpValid) {
      // Proceed with update
      await performUpdate();
    }
  };

  const performUpdate = async () => {
    setUpdating(true);
    try {
      console.log("Updating customer with data:", updateData);

      const response = await authAxios.put(
        `${ADMIN_API_BASE_URL}/main/admin/edit-customer/${customer.mobileNumber}`,
        updateData
      );

      toast.success("Customer updated successfully!");
      setShowOtpModal(false);
      navigate(`/admin/customer-view/${id}`);
    } catch (error) {
      console.error("Error updating customer:", error);
      toast.error("Failed to update customer");
    } finally {
      setUpdating(false);
    }
  };

  const handleCancel = () => {
    navigate(`/admin/customer-view/${id}`);
  };

  const handleBack = () => {
    navigate(`/admin/customer-view/${id}`);
  };

  const handleResendOtp = async () => {
    const otpSent = await sendOtp();
    if (otpSent) {
      setOtp("");
      toast.info("New OTP sent successfully");
    }
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    return dateString.split('T')[0];
  };

  const FormGroup = ({ icon: Icon, label, name, value, type = "text", placeholder, required = false, ...props }) => (
    <Form.Group className="mb-3">
      <Form.Label className="d-flex align-items-center fw-semibold text-dark">
        <Icon className="me-2 text-primary" size={14} />
        {label}
        {required && <span className="text-danger ms-1">*</span>}
      </Form.Label>
      <Form.Control
        type={type}
        name={name}
        value={value || ""}
        onChange={handleInputChange}
        placeholder={placeholder}
        required={required}
        {...props}
      />
    </Form.Group>
  );

  if (loading) {
    return (
      <Base>
        <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      </Base>
    );
  }

  if (error) {
    return (
      <Base>
        <div className="alert alert-danger text-center mx-3">{error}</div>
      </Base>
    );
  }

  if (!customer) {
    return (
      <Base>
        <div className="alert alert-warning text-center mx-3">Customer not found</div>
      </Base>
    );
  }

  return (
    <Base>
      <div className="container-fluid pt-3 mt-5">
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/admin/dashboard" sx={{ color: "darkslategrey", fontWeight: "bold" }}>
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="/admin/customer-management" sx={{ color: "darkslategrey", fontWeight: "bold" }}>
            Customer Management
          </Link>
          <Link underline="hover" color="inherit" href={`/admin/customer-view/${id}`} sx={{ color: "darkslategrey", fontWeight: "bold" }}>
            View Customer
          </Link>
          <Link underline="none" color="inherit" sx={{ color: "darkslategrey", fontWeight: "bold" }}>
            Edit Customer
          </Link>
        </Breadcrumbs>
      </div>

      <div className="container-fluid mt-3">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="fw-bold text-dark mb-1">Edit Customer</h2>
            <p className="text-muted mb-0">Update customer information</p>
          </div>
          <div className="d-flex gap-2">
            <Button variant="outline-secondary" onClick={handleBack}>
              <ArrowBackIcon className="me-1" /> Back to List
            </Button>
          </div>
        </div>

        <Form onSubmit={handleSubmit}>
          <Row>
            {/* Customer Information */}
            <Col md={8}>
              {/* Personal Information */}
              <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0">
                  <Card.Title className="mb-0 d-flex align-items-center">
                    <FaUser className="me-2 text-primary" />
                    Personal Information
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={6}>
                      <FormGroup
                        icon={FaUser}
                        label="Customer Name"
                        name="customerName"
                        value={customer.customerName}
                        required
                      />
                      <FormGroup
                        icon={FaUser}
                        label="Father Name"
                        name="fatherName"
                        value={customer.fatherName}
                      />
                      <FormGroup
                        icon={FaPhone}
                        label="Mobile Number"
                        name="mobileNumber"
                        value={customer.mobileNumber}
                        type="tel"
                        required
                      />
                      <FormGroup
                        icon={FaEnvelope}
                        label="Email"
                        name="email"
                        value={customer.email}
                        type="email"
                      />
                    </Col>
                    <Col md={6}>
                      <FormGroup
                        icon={FaCalendarAlt}
                        label="Date of Birth"
                        name="dateOfBirth"
                        value={formatDateForInput(customer.dateOfBirth)}
                        type="date"
                      />
                      <FormGroup
                        icon={FaUser}
                        label="Age"
                        name="age"
                        value={customer.age}
                        type="number"
                      />
                      <FormGroup
                        icon={FaUser}
                        label="Nominee Name"
                        name="nomineeName"
                        value={customer.nomineeName}
                      />
                      <FormGroup
                        icon={FaBriefcase}
                        label="Occupation"
                        name="occupation"
                        value={customer.occupation}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Address Information */}
              <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0">
                  <Card.Title className="mb-0 d-flex align-items-center">
                    <FaMapMarkerAlt className="me-2 text-primary" />
                    Address Information
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={6}>
                      <FormGroup
                        icon={FaBuilding}
                        label="Primary Address"
                        name="primaryAddress"
                        value={customer.primaryAddress}
                        as="textarea"
                        rows={3}
                      />
                      <FormGroup
                        icon={FaBuilding}
                        label="City"
                        name="city"
                        value={customer.city}
                      />
                    </Col>
                    <Col md={6}>
                      <FormGroup
                        icon={FaMapMarkerAlt}
                        label="Pincode"
                        name="pincode"
                        value={customer.pincode}
                        type="text"
                      />
                      <FormGroup
                        icon={FaUsers}
                        label="Group Name"
                        name="groupName"
                        value={customer.groupName}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Document Information */}
              <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0">
                  <Card.Title className="mb-0 d-flex align-items-center">
                    <FaIdCard className="me-2 text-primary" />
                    Document Information
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={6}>
                      <FormGroup
                        icon={FaIdCard}
                        label="Aadhar Number"
                        name="aadharNumber"
                        value={customer.aadharNumber}
                      />
                      <FormGroup
                        icon={FaIdCard}
                        label="PAN Number"
                        name="panNumber"
                        value={customer.panNumber}
                      />
                    </Col>
                    <Col md={6}>
                      <FormGroup
                        icon={FaIdCard}
                        label="Passbook Number"
                        name="passbook"
                        value={customer.passbook}
                      />
                      <FormGroup
                        icon={FaIdCard}
                        label="Document Name"
                        name="documentName"
                        value={customer.documentName}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Employee Assignment */}
              <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0">
                  <Card.Title className="mb-0 d-flex align-items-center">
                    <FaUser className="me-2 text-primary" />
                    Employee Assignment
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Form.Group className="mb-3">
                    <Form.Label className="d-flex align-items-center fw-semibold text-dark">
                      <FaUser className="me-2 text-primary" size={14} />
                      Assigned Employee
                    </Form.Label>
                    <Form.Select
                      value={customer.employee ? customer.employee.id : ""}
                      onChange={handleEmployeeChange}
                    >
                      <option value="">No Employee Assigned</option>
                      {allEmployees.map((employee) => (
                        <option key={employee.id} value={employee.id}>
                          {employee.fullName} ({employee.employeeReferenceId})
                        </option>
                      ))}
                    </Form.Select>
                    {customer.employee && (
                      <div className="mt-2 p-2 bg-light rounded">
                        <small className="text-muted">
                          Current: {customer.employee.fullName} - {customer.employee.designation} 
                          ({customer.employee.employeeReferenceId})
                        </small>
                      </div>
                    )}
                  </Form.Group>
                </Card.Body>
              </Card>

              {/* Status */}
              <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0">
                  <Card.Title className="mb-0 d-flex align-items-center">
                    <FaIdCard className="me-2 text-primary" />
                    Status
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Active Customer"
                      name="status"
                      checked={customer.status}
                      onChange={handleInputChange}
                    />
                    <Form.Text className="text-muted">
                      Uncheck to deactivate this customer
                    </Form.Text>
                  </Form.Group>
                </Card.Body>
              </Card>
            </Col>

            {/* Images Section */}
            <Col md={4}>
              <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0">
                  <Card.Title className="mb-0">Profile Image</Card.Title>
                </Card.Header>
                <Card.Body className="text-center">
                  <img 
                    src={customer.profileImagePath} 
                    alt="Profile"
                    className="img-fluid rounded mb-2"
                    style={{ maxHeight: "200px" }}
                  />
                  <div className="text-muted small">
                    Profile Image (Read-only)
                  </div>
                </Card.Body>
              </Card>

              <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0">
                  <Card.Title className="mb-0">Signature</Card.Title>
                </Card.Header>
                <Card.Body className="text-center">
                  {customer.customerSignature ? (
                    <img
                      src={customer.customerSignature} 
                      alt="Signature"
                      className="img-fluid rounded mb-2"
                      style={{ maxHeight: "150px" }}
                    />
                  ) : (
                    <div className="text-muted py-4">No signature available</div>
                  )}
                  <div className="text-muted small">
                    Customer Signature (Read-only)
                  </div>
                </Card.Body>
              </Card>

              <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0">
                  <Card.Title className="mb-0">Aadhar Card</Card.Title>
                </Card.Header>
                <Card.Body className="text-center">
                  {customer.aadharImage ? (
                    <img
                      src={customer.aadharImage} 
                      alt="Aadhar Card"
                      className="img-fluid rounded mb-2"
                      style={{ maxHeight: "200px" }}
                    />
                  ) : (
                    <div className="text-muted py-4">No Aadhar image available</div>
                  )}
                  <div className="text-muted small">
                    Aadhar Card (Read-only)
                  </div>
                </Card.Body>
              </Card>

              <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-light border-0">
                  <Card.Title className="mb-0">PAN Card</Card.Title>
                </Card.Header>
                <Card.Body className="text-center">
                  {customer.panImage ? (
                    <img
                      src={customer.panImage} 
                      alt="PAN Card"
                      className="img-fluid rounded mb-2"
                      style={{ maxHeight: "200px" }}
                    />
                  ) : (
                    <div className="text-muted py-4">No PAN image available</div>
                  )}
                  <div className="text-muted small">
                    PAN Card (Read-only)
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Action Buttons */}
          <Card className="mb-4 shadow-sm border-0">
            <Card.Body className="text-center">
              <div className="d-flex justify-content-center gap-3">
                <Button 
                  variant="outline-secondary" 
                  onClick={handleCancel}
                  disabled={updating || sendingOtp}
                  size="lg"
                >
                  <CancelIcon className="me-1" /> Cancel
                </Button>
                <Button 
                  variant="primary" 
                  type="submit"
                  disabled={updating || sendingOtp}
                  size="lg"
                >
                  {sendingOtp ? (
                    <>
                      <ClipLoader color="#fff" size={20} className="me-2" />
                      Sending OTP...
                    </>
                  ) : updating ? (
                    <>
                      <ClipLoader color="#fff" size={20} className="me-2" />
                      Updating...
                    </>
                  ) : (
                    <>
                      <FaShieldAlt className="me-1" /> Update with OTP
                    </>
                  )}
                </Button>
              </div>
              <div className="mt-2">
                <small className="text-muted">
                  <FaShieldAlt className="me-1" />
                  OTP verification required for updating customer details
                </small>
              </div>
            </Card.Body>
          </Card>
        </Form>
      </div>

      {/* OTP Verification Modal */}
      <Modal show={showOtpModal} onHide={() => !verifyingOtp && setShowOtpModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center">
            <FaShieldAlt className="me-2 text-primary" />
            OTP Verification Required
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            We've sent an OTP to your registered mobile number ending with{" "}
            <strong>{customer.mobileNumber.slice(-4)}</strong>.
            Please enter the OTP to verify and update the customer details.
          </p>
          
          <Form.Group className="mb-3">
            <Form.Label>Enter OTP</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter 6-digit OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
              maxLength={6}
            />
          </Form.Group>

          <div className="d-flex justify-content-between align-items-center">
            <Button 
              variant="outline-primary" 
              onClick={handleResendOtp}
              disabled={sendingOtp}
              size="sm"
            >
              {sendingOtp ? "Sending..." : "Resend OTP"}
            </Button>
            
            <div className="d-flex gap-2">
              <Button 
                variant="outline-secondary" 
                onClick={() => setShowOtpModal(false)}
                disabled={verifyingOtp || updating}
              >
                Cancel
              </Button>
              <Button 
                variant="primary" 
                onClick={handleOtpVerification}
                disabled={verifyingOtp || updating || !otp}
              >
                {verifyingOtp ? (
                  <>
                    <ClipLoader color="#fff" size={16} className="me-2" />
                    Verifying...
                  </>
                ) : updating ? (
                  <>
                    <ClipLoader color="#fff" size={16} className="me-2" />
                    Updating...
                  </>
                ) : (
                  "Verify & Update"
                )}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Base>
  );
};

export default CustomerEdit;